/*
 * @Descripttion: 订阅发布模式
 * @Author: zhanghang
 * @Date: 2021-07-29 15:22:32
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-09-21 16:33:03
 */
class Emit {
  constructor() {
    this.events = {}// 订阅的事件
  }
  $on(event, cb, subscribe) {
    let events = this.events[event] ? this.events[event] : []
    events.push([subscribe, cb])
    this.events[event] = events
  }
  $emit(event, data, subscribes = []) {
    this.events[event]?.forEach((item) => {
      //只通知特定订阅者
      if (subscribes.length) {
        subscribes.forEach(it => {
          if (item[0] === it) {
            item[1].call(item[0], data)
          }
        })
      } else {
        item[1].call(item[0], data)
      }
    })
  }
  $hasEvent(event, subscribe) {
    return this.events[event] && this.events[event].findIndex((d) => d[0] === subscribe) > -1
  }
  $remove(event, subscribe, cb) {
    let events = this.events[event]
    if (events) {
      //只移除特定的监听方法
      if (cb) {
        events = events.filter(d => (d[0] !== subscribe || d[1] !== cb))
        //只要有tag对象监听的该事件全部移除
      } else {
        events = events.filter(d => d[0] !== subscribe)
      }
      this.events[event] = events
    }

  }

}
export default new Emit()